export const promoApi = '/api/v1/videos/promo_videos/';
